import { Typography } from "@mui/material";
import { Col, Row } from "v2/components/base/Flex/ui";

const ModelContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <Row section="content" fullHeight fullWidth>
      <Col fullHeight fullWidth>
        {children}
      </Col>
    </Row>
  );
};

export default ModelContent;
